import { render, staticRenderFns } from "./PriceConfig.vue?vue&type=template&id=0f695aca&scoped=true&"
import script from "./PriceConfig.vue?vue&type=script&lang=js&"
export * from "./PriceConfig.vue?vue&type=script&lang=js&"
import style0 from "./PriceConfig.vue?vue&type=style&index=0&id=0f695aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f695aca",
  null
  
)

export default component.exports